import ReactDOM from 'react-dom'

export const main = async () => {
  await import('./Root').then(({ default: Root }) => {
    ReactDOM.render(<Root />, document.getElementById('root'))
  })

  // Set the theme on first load
  if (typeof localStorage !== 'undefined' && localStorage.getItem('theme')) {
    let theme = localStorage.getItem('theme')

    if (!theme || theme === 'system') {
      theme = window?.matchMedia('(prefers-color-scheme: dark)')?.matches
        ? 'dark'
        : 'light'
    }

    document?.documentElement?.classList?.toggle?.(theme)
  }
}

main()
